import { QuestionType } from '@/contracts/enums/questionTypes';
import { OptionItem } from '@/contracts/models/survey';
import { useTranslation } from '@/hooks/useTranslation';
import React, { ReactNode } from 'react';
import { ReorderableList } from './ReorderableList';

export interface ChoiceSelectorProps {
  choices: OptionItem[];
  onChange: (choices: OptionItem[]) => void;
  disabled?: boolean;
  lockStructure?: boolean;
  originalChoices?: string[];
  questionType?: QuestionType;
  renderItemSuffix?: (index: number) => ReactNode;
}

export const ChoiceSelector: React.FC<ChoiceSelectorProps> = ({
  choices,
  onChange,
  disabled = false,
  lockStructure = false,
  originalChoices,
  questionType = QuestionType.RadioGroup,
  renderItemSuffix,
}) => {
  const { t } = useTranslation();

  // Determine if this is a multiple choice question (checkbox or tagbox) or single choice (radio)
  const isMultipleChoice =
    questionType === QuestionType.Checkbox ||
    questionType === QuestionType.MultiSelectDropdown;

  const renderLeadingIcon = () => (
    <span
      className={`w-6 h-6 flex items-center justify-center border border-gray-300 flex-shrink-0 ${
        isMultipleChoice ? 'rounded-sm' : 'rounded-full'
      }`}
      aria-hidden='true'
    >
      {isMultipleChoice ? (
        <i className='pi pi-square text-xs text-gray-400' />
      ) : (
        <i className='pi pi-circle text-xs text-gray-400' />
      )}
    </span>
  );

  return (
    <ReorderableList
      items={choices}
      onChange={onChange}
      disabled={disabled}
      lockStructure={lockStructure}
      originalItems={originalChoices}
      minItems={2}
      itemType='choice'
      t={t}
      renderLeadingIcon={renderLeadingIcon}
      renderItemSuffix={renderItemSuffix}
    />
  );
};
